import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledMagistralDrugTemplateReadOnly = styled(StyledFlex)`
   width: 100%;
`;
